exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb {\n  width: 100%;\n}\n.breadcrumb .breadcrumb-box {\n  color: #9e9e9e;\n  font-size: 14px;\n  height: 50px;\n}\n.breadcrumb .breadcrumb-box span {\n  line-height: 50px;\n  margin: 0 10px;\n  color: #1c61a0;\n}\n.breadcrumb .breadcrumb-box span:first-child {\n  margin-left: 0;\n}\n.breadcrumb .breadcrumb-box span:last-child {\n  color: #9e9e9e;\n}\n.breadcrumb .breadcrumb-box img {\n  height: 12px;\n  padding-right: 8px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/share/breadcrumb/breadcrumb.component.styl
// module id = ../../../../../src/app/share/breadcrumb/breadcrumb.component.styl
// module chunks = main